export const categoriesData = [
    {
      _id: "0",
      imgdef: 'alltest-b.png',
      imgactive: 'alltest-w.png',
      heading: 'All Tests',
      slug: 'all',
      description: "A comprehensive list of all the blood tests we offer, organised alphabetically. It allows you to easily browse through and search available tests to help select the one that best suits your needs. Use the filter to search by all blood tests or by health categories above. If you can not find a test you are looking for, please contact us - we may be able to offer it!",
      description_2: "A biomarker is a specific indicator in your blood, while a profile combines multiple biomarkers to provide a broader, more comprehensive test."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca2",
      imgdef: 'heartpulse-b.png',
      imgactive: 'heartpulse-w.png',
      heading: 'General Health Tests',
      slug: "general-health",
      description: "Comprehensive blood tests to assess overall health, including vital organ function and key markers."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca3",
      imgdef: 'user-b.png',
      imgactive: 'user-w.png',
      heading: 'Mens Health',
      slug: "mens-health",
      description: "Blood tests designed to monitor testosterone levels, prostate health, and overall well-being for men."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca4",
      imgdef: 'smile-b.png',
      imgactive: 'smile-w.png',
      heading: 'Mood Tests',
      slug: "mood",
      description: "Tests to check hormone and vitamin levels that impact mood, stress, and mental well-being."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca5",
      imgdef: 'apple-b.png',
      imgactive: 'apple-w.png',
      heading: 'Nutrition',
      slug: "nutrition",
      description: "Assess key vitamins, minerals, and nutrients to ensure optimal dietary balance and health."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca6",
      imgdef: 'hold-b.png',
      imgactive: 'hold-w.png',
      heading: 'Sexual Health/Fertility',
      slug: "sexual-health-fertility",
      description: "Blood tests to check hormone levels, reproductive health, and fertility status for men and women."
    },
    {
      _id: "67ab62a57f2a122e8bd55ca7",
      imgdef: 'fitness-b.png',
      imgactive: 'fitness-w.png',
      heading: 'Sports/Fitness',
      slug: "sports-fitness",
      description: "Tests to track fitness levels, muscle recovery, and key health markers for performance optimization."
    },
    {
      _id: "67ab62a67f2a122e8bd55ca8",
      imgdef: 'tired-b.png',
      imgactive: 'tired-w.png',
      heading: 'Tiredness & Fatigue Tests',
      slug: "tiredness-fatigue",
      description: "Identify possible causes of low energy, including iron levels, thyroid function, and vitamin deficiencies."
    },
    {
      _id: "67ab62a67f2a122e8bd55ca9",
      imgdef: 'weight-b.png',
      imgactive: 'weight-w.png',
      heading: 'Weight',
      slug: "weight",
      description: "Check hormone and metabolic markers that influence weight gain, loss, and overall metabolism."
    },
    {
      _id: "67ab62a67f2a122e8bd55caa",
      imgdef: 'women-b.png',
      imgactive: 'women-w.png',
      heading: "Women's Health",
      slug: "womens-health",
      description: "Comprehensive tests for hormonal balance, reproductive health, and overall well-being in women."
    },
  ];
  